import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import IMaterial, { IClassification } from '@/interfaces/material';

function getMaterials(): Observable<IMaterial[]> {
  return from(apiClient.get(ENDPOINTS.MATERIALS)).pipe(map((r: any) => r.data));
}
function saveMaterial(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.MATERIAL, payload)).pipe(
    map((r: any) => r.data),
  );
}
function updateMaterial(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.MATERIAL, payload)).pipe(
    map((r: any) => r.data),
  );
}
function deleteMaterial(id: number): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.MATERIAL}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function getClassifications(): Observable<IClassification[]> {
  return from(apiClient.get(ENDPOINTS.MATERIALS_CLASSIFICATIONS)).pipe(
    map((r: any) => r.data),
  );
}

export {
  getMaterials,
  saveMaterial,
  updateMaterial,
  deleteMaterial,
  getClassifications,
};
